import type {
  GroupResource,
  UserAcceptResource,
} from 'entities/document/model';

export const participantIsDone = (
  participant: UserAcceptResource | GroupResource<UserAcceptResource>,
): boolean => {
  if (participant.type === 'participant-user') {
    return participant.parameters.status === 'done';
  }

  if (participant.type === 'participant-group') {
    return participant.parameters.participants.every(participantIsDone);
  }

  return false;
};
